import _implicitStylesheets from "./labeledValue.css";
import _implicitScopedStylesheets from "./labeledValue.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="labeled-value__title-text${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "labeled-value": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "labeled-value__group": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "labeled-value__title": true
  },
  attrs: {
    "type-style": "body-2",
    "data-testid": "labeled-value-title"
  },
  key: 2
};
const stc3 = {
  attrs: {
    "name": "title-adornment"
  },
  key: 5
};
const stc4 = [];
const stc5 = {
  "labeled-value__content": true
};
const stc6 = {
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, s: api_slot, h: api_element} = $api;
  return [api_element("dl", stc0, [api_element("div", stc1, [api_element("dt", stc2, [api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.title))]), api_slot("title-adornment", stc3, stc4, $slotset)]), api_element("dd", {
    classMap: stc5,
    attrs: {
      "data-testid": "labeled-value-content",
      "aria-label": $cmp.contentAriaLabel
    },
    key: 6
  }, [api_slot("", stc6, stc4, $slotset)])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["", "title-adornment"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-799vul3c01l";
tmpl.legacyStylesheetToken = "undefined-_labeledValue";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
